define([
    'text!product-detail/component/material-list.html',
    'product-detail/mixin/product',
    // 'product-detail/furniture/material-item',
    'lodash',

    'css!product-detail/component/material-list.css'
], function(
    tpl,
    ProductMixin,
    // MaterialItem,
    _
){
    return {
        template: tpl,
        mixins: [ProductMixin],
        data: function(){
            return {
                activeMaterial: null
            };
        },
        components: {
            // MaterialItem: MaterialItem
        },
        computed: {
            materials: function(){
                if (!this.spuExtraBase.materialData) return [];
                var materialData = this.spuExtraBase.materialData;
                var isOpen = materialData.length < 5;
                // console.log(materialData);
                return _.map(materialData, function(o, index){
                    o.index = index+1;
                    // o.isOpen = isOpen;
                    o.isOpen = true;
                    return o;
                });
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/material-list.js
// module id = 134
// module chunks = 0